export default __webpack_public_path__ + "static/media/email.5ece96e7.svg";